import { gql } from '@apollo/client';

const NOTE_FIELDS = `
  noteId
  text
  sticky
  author
  createdAt
  updatedAt
  updatedBy
`;

export const GET_INTERNAL_UW_NOTES = gql`
  query GetInternalUwNotes($offerId: ID, $policyId: ID) {
    getInternalUwNotes(offerId: $offerId, policyId: $policyId) {
      __typename
      ... on InternalUwNotesResponse {
        success
        notes { ${NOTE_FIELDS} }
      }
      ... on InternalUwNotesError {
        success
        error
      }
    }
  }
`;

const NOTE_RESULT = `
  __typename
  ... on InternalUwNoteResponse {
    success
    note { ${NOTE_FIELDS} }
  }
  ... on InternalUwNotesError {
    success
    error
  }
`;

export const ADD_INTERNAL_UW_NOTE = gql`
  mutation AddInternalUwNote($input: AddInternalUwNoteInput!) {
    addInternalUwNote(input: $input) { ${NOTE_RESULT} }
  }
`;

export const EDIT_INTERNAL_UW_NOTE = gql`
  mutation EditInternalUwNote($input: EditInternalUwNoteInput!) {
    editInternalUwNote(input: $input) { ${NOTE_RESULT} }
  }
`;

export const SET_INTERNAL_UW_NOTE_STICKY = gql`
  mutation SetInternalUwNoteSticky($input: SetInternalUwNoteStickyInput!) {
    setInternalUwNoteSticky(input: $input) { ${NOTE_RESULT} }
  }
`;

export const DELETE_INTERNAL_UW_NOTE = gql`
  mutation DeleteInternalUwNote($input: DeleteInternalUwNoteInput!) {
    deleteInternalUwNote(input: $input) { ${NOTE_RESULT} }
  }
`;
